


















































import Vue from "vue";
import {
  InitialLoadShwState,
  InitialLoadShw4State,
} from "@/models/InitialLoadShowState";
import Show from "@/models/Show";
import { Mutations } from "@/store/mutations";
import InitialShowState from "@/models/InitialShowState";

export default Vue.extend({
  name: "LoadModal",
  data: (): {
    file: File | null;
    showLoadState: InitialShowState | null;
    showPreview: Show | null;
    parseError: string;
  } => ({ file: null, showLoadState: null, showPreview: null, parseError: "" }),
  computed: {
    numMarchers(): number {
      return this.showPreview && this.showPreview.stuntSheets.length > 0
        ? this.showPreview?.stuntSheets[0].stuntSheetDots.length
        : 0;
    },
    numSheets(): number {
      return this.showPreview ? this.showPreview.stuntSheets.length : 0;
    },
  },
  methods: {
    loadShow(): void {
      if (this.file === null) {
        return;
      }
      this.showPreview = null;
      this.parseError = "";
      const reader = new FileReader();
      // Check if calchart 4 or not...
      if (this.file.name.includes(".shw4")) {
        reader.onload = (): void => {
          if (reader.result) {
            try {
              this.showLoadState = new InitialLoadShw4State({
                showData: reader.result as string,
              });
              this.showPreview = this.showLoadState.getInitialState();
            } catch (e) {
              this.parseError = e;
            }
          } else {
            this.parseError = "Could not read file.";
          }
        };
        reader.readAsText(this.file);
      } else if (this.file.name.includes(".shw")) {
        reader.onload = (): void => {
          if (
            reader.result &&
            this.file &&
            reader.result instanceof ArrayBuffer
          ) {
            try {
              this.showLoadState = new InitialLoadShwState({
                showData: reader.result,
                fileName: this.file.name,
              });
              this.showPreview = this.showLoadState.getInitialState();
            } catch (e) {
              this.parseError = e;
            }
          } else {
            this.parseError = "Could not read file.";
          }
        };
        reader.readAsArrayBuffer(this.file);
      } else {
        this.parseError = "Not a .shw or .shw4 file.";
      }
    },
    setShow(): void {
      if (!this.showPreview) {
        return;
      }
      this.$store.commit(Mutations.SET_NEW_SHOW, this.showLoadState);
    },
  },
});
